import { FETCH_CARD_PENDING_CUSTOMERS } from '../actions/types';

const initialState = {
    items: [],
    pagination: { currentPage: 1, total: 0, perPage: 30 }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_CARD_PENDING_CUSTOMERS:
            return {
                ...state,
                items: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload?.current_page || 1, 10),
                    total: parseInt(action.payload?.total || 0, 10),
                    perPage: parseInt(action.payload?.per_page || 30, 10)
                }
            };
        default:
            return state;
    }
};
